// Shared layout for the pickup app: clean WHITE sticky header with the IceOps
// shield lockup linking home, light page body, and a muted footer carrying the
// "Website by LooniTech Labs" credit. No em dashes anywhere - use " - ".

import { Link } from 'react-router-dom'

export default function PickupLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-slate-50 text-slate-900">
      <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-3.5">
          <Link
            to="/"
            className="flex items-center gap-2"
            aria-label="IceOps Pickup home"
          >
            <img src="/shield-logo.png" alt="IceOps" className="h-8 w-auto" />
            <span className="text-xl font-bold text-slate-900">IceOps</span>
            <span className="text-xl font-semibold text-ice-600">Pickup</span>
          </Link>
          <Link
            to="/admin"
            className="text-base font-medium text-slate-600 hover:text-ice-600"
          >
            Admin
          </Link>
        </div>
      </header>

      <main className="mx-auto w-full max-w-4xl flex-1 px-4 py-6">{children}</main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="mx-auto max-w-4xl px-4 py-6 text-center text-sm text-slate-500">
          <span>
            Website by{' '}
            <a
              href="https://loonitechlabs.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-600 hover:text-ice-600"
            >
              LooniTech Labs
            </a>
          </span>
        </div>
      </footer>
    </div>
  )
}
